export default __webpack_public_path__ + "static/illustration-visual-changes-aa3f82cfbde9dc99bc93933863b6778d.svg";